import Vue from 'vue';
import axios from 'axios';
import router from './router';
import { store } from './store';
import VueCookie from 'vue-cookie';
import sha256 from 'js-sha256';
import base64 from 'base-64';
import utf8 from 'utf8';
Vue.use(VueCookie, sha256, base64, utf8);

export const helper = {
  apiUrl: window.location.protocol + '//' + window.location.host + '/api',
  getAuthHeader: () => {
    let sId = Vue.cookie.get('PHPSESSID'),
      header = {'Content-Type': 'application/json'};
    if (typeof localStorage.token !== 'undefined' && typeof sId !== 'undefined') {
      let hash = sha256.create();
      hash.update(utf8.decode(base64.decode(localStorage.token)) + ':gt:' + sId);
      header.Authorization = 'Bearer ' + hash.hex();
      return header;
    }
    return header;
  },
  showLogin(response) {
    return (typeof response.data !== 'undefined') &&
      (typeof response.data.authStatus !== 'undefined');
  },
  showErrorModal(data) {
    if (!(jQuery('#alert_modal').hasClass('show'))) {
      store.dispatch('alert/error', data.message);
      jQuery('#alert_modal').modal('show');
      setTimeout(() => {
        store.dispatch('alert/clear');
        jQuery('#alert_modal').modal('hide');
      }, 5000);
    }
    if (data.logout) {
      helper.finishLogout();
    }
  },
  showSuccessModal(message) {
    store.dispatch('alert/success', message);
    helper.triggerMessageModal('#alert_modal');
  },
  finishLogout() {
    localStorage.clear();
    router.push('/login');
  },
  getQueryString(data) {
    let tz = new Date().getTimezoneOffset();
    tz = tz === 0 ? 0 : - tz;
    if (data === null) {
      return '&tz=' + tz;
    }
    let queryString = [];
    Object.keys(data).forEach((key) => {
      queryString.push(key + '=' + data[key]);
    });
    queryString.push('tz=' + tz);
    return '&' + queryString.join('&');
  },
  sendRequest: (url, data = null) => {
    let errorResult = {message: '', logout: false};
    return axios.get(
      helper.apiUrl + url + helper.getQueryString(data),
      { headers: helper.getAuthHeader() }
    ).then(response => {
      if (response.data.status === 'success') {
        return response.data.data;
      }
      if (helper.showLogin(response.data)) {
        errorResult.logout = true;
      }
      errorResult.message = response.data.message;
      helper.showErrorModal(errorResult);
      return [];
    }).catch(function() {
      return [];
    });
  },
  sendPostRequest: (url, data) => {
    let errorResult = {status: 'error', message: '', logout: false};
    return axios.post(
      helper.apiUrl + url + helper.getQueryString(null), data, { headers: helper.getAuthHeader() }
      ).then(response => {
        if (response.data.status === 'success') {
          return response.data;
        }
        if (helper.showLogin(response.data)) {
          errorResult.logout = true;
          errorResult.message = response.data.message;
          helper.showErrorModal(errorResult);
        }
        return response.data;
      }).catch(() => {
        errorResult.message = 'Unable to handle the request.';
        return errorResult;
      });
  },
  getPlantBatches: () => {
    return helper.sendRequest('/plantbatches/active').then(function(data) {
      return data;
    });
  },
  getStrains: () => {
    return helper.sendRequest('/strains/active').then(function(data) {
      return data;
    });
  },
  getRooms: () => {
    return helper.sendRequest('/rooms/active').then(function(data) {
      return data;
    });
  },
  getItems: () => {
    return helper.sendRequest('/items/active').then(function(data) {
      return data;
    });
  },
  getPackages: () => {
    return helper.sendRequest('/packages/active').then(function(data) {
      return data;
    });
  },
  getVegetativePlants: () => {
    return helper.sendRequest('/plants/vegetative').then(function(data) {
      return data;
    });
  },
  getFloweringPlants: () => {
    return helper.sendRequest('/plants/flowering').then(function(data) {
      return data;
    });
  },
  getHarvests: () => {
    return helper.sendRequest('/harvests/active').then(function(data) {
      return data;
    });
  },
  getGrowthPhases: () => {
    return helper.sendRequest('/plants/growthphases').then(function(data) {
      return data;
    });
  },
  getPlantBatchTypes: () => {
    return helper.sendRequest('/plantbatches/types').then(function(data) {
      return data;
    });
  },
  getItemCategories: () => {
    return helper.sendRequest('/items/categories').then(function(data) {
      return data;
    });
  },
  getUnitOfMeasurement: () => {
    return helper.sendRequest('/unitsofmeasure/active').then(function(data) {
      return data;
    });
  },
  getItemBrands: () => {
    return helper.sendRequest('/items/brands').then(function(data) {
      return data;
    });
  },
  getWasteTypes: () => {
    return helper.sendRequest('/harvests/waste_types').then(function(data) {
      return data;
    });
  },
  getAdjustReasons: () => {
    return helper.sendRequest('/packages/adjust_reasons').then(function(data) {
      return data;
    });
  },
  getUserData: () => {
    let email = utf8.decode(base64.decode(localStorage.token));
    return helper.sendPostRequest('/user/get', {email: email}).then(function(data) {
      return data;
    });
  },
  getTodoList: () => {
    return helper.sendRequest('/todo/get', { 'status': 'all' }).then(function(data) {
      return data;
    });
  },
  getRecentNotificationList: () => {
    return helper.sendRequest(
      '/todo/get',
      { 'status': 'active', 'startDate': 'past', 'limit': 10, 'order': 'DESC' }
    ).then((data) => {
      return data;
    });
  },
  getRecentNotificationCount: () => {
    return helper.sendRequest(
      '/todo/get',
      { 'status': 'active', 'recentNotifications': 1, 'startDate': 'today' }
    ).then((data) => {
      return data;
    });
  },
  loadSiteData() {
    if (store.getters['library/getUserData'] === null) {
      store.dispatch('library/getAllUserData');
    }
    if (store.getters['library/getStrains'].length === 0) {
      store.dispatch('library/getAllStrains');
    }
    if (store.getters['library/getRooms'].length === 0) {
      store.dispatch('library/getAllRooms');
    }
    if (store.getters['library/getPlantBatches'].length === 0) {
      store.dispatch('library/getAllPlantBatches');
    }
    if (store.getters['library/getItems'].length === 0) {
      store.dispatch('library/getAllItems');
    }
    if (store.getters['library/getPackages'].length === 0) {
      store.dispatch('library/getAllPackages');
    }
    if (store.getters['library/getHarvests'].length === 0) {
      store.dispatch('library/getAllHarvests');
    }
    if (store.getters['library/getVegetativePlants'].length === 0) {
      store.dispatch('library/getAllVegetativePlants');
    }
    if (store.getters['library/getFloweringPlants'].length === 0) {
      store.dispatch('library/getAllFloweringPlants');
    }
    if (store.getters['library/getGrowthPhases'].length === 0) {
      store.dispatch('library/getAllGrowthPhases');
    }
    if (store.getters['library/getPlantBatchTypes'].length === 0) {
      store.dispatch('library/getAllPlantBatchTypes');
    }
    if (store.getters['library/getItemCategories'].length === 0) {
      store.dispatch('library/getAllItemCategories');
    }
    if (store.getters['library/getUnitOfMeasurement'].length === 0) {
      store.dispatch('library/getAllUnitOfMeasurement');
    }
    if (store.getters['library/getWasteTypes'].length === 0) {
      store.dispatch('library/getAllWasteTypes');
    }
    if (store.getters['library/getAdjustReasons'].length === 0) {
      store.dispatch('library/getAllAdjustReasons');
    }
    if (store.getters['library/getTodoList'] === null) {
      store.dispatch('library/getAllTodoList');
    }
  },
  triggerMessageModal(id) {
    jQuery(id).modal('show');
    setTimeout(() => {
      store.dispatch('alert/clear');
      jQuery(id).modal('hide');
    }, 5000);
  },
  prepareDataTable(id, length = 5) {
    setTimeout(
      function(){
        jQuery(id).DataTable({
          pageLength: length,
          lengthMenu: [[5, 10, 15, 20], [5, 10, 15, 20]],
          autoWidth: false
        });
      },
      100
    );
  }
};


// WEBPACK FOOTER //
// ./source/helper.js